var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"data-status":_setup.status}},[_c('i',[_vm._v("●")]),_c('div',{staticClass:"details-container"},[_c('ul',{staticClass:"details"},[_c('li',[_vm._v(_vm._s(_setup.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }